<mat-card class="card widget-card" [id]="widget.id">
    <mat-card-title>
        <div>
            <div class="header widget-card__header">
                <div class="title widget-card__title-group">
                    <p *ngIf="!editVisible">{{widget.name}}</p>
                    <input *ngIf="editVisible" type="text" [(ngModel)]="newName" class="widget-rename-input">
                    <span class="widget-card__meta" *ngIf="!editVisible">{{ widget.items?.length || 0 }} {{ 'TRACKED_STATS' | translate }}</span>
                </div>
                <div class="seperator"></div>
                <div class="widget-actions" *ngIf="!editVisible">
                    <div *ngIf="!changeLayoutStarted">
                        <a role="button" class="widget-icon-action" (click)="edit()">
                            <i class="fas fa-edit fa-xs"></i>
                        </a>
                        <a role="button" class="widget-icon-action" (click)="refresh()">
                            <i class="fas fa-sync-alt fa-xs"></i>
                        </a>
                        <a role="button" class="widget-icon-action" (click)="removeWidget()">
                            <i class="fas fa-times fa-xs"></i>
                        </a>
                    </div>
                    <div *ngIf="changeLayoutStarted">
                        <i class="fas fa-bars fa-xs draghandler widget-drag-handle"></i>
                    </div>
                </div>
            </div>
        </div>
    </mat-card-title>
    <mat-card-content>
        <div [sortablejs]="localItems" [sortablejsOptions]="getSortableOptions(widget)" class="widget-items" [class.widget-items--empty]="!localItems?.length">
            <ng-container *ngIf="localItems?.length; else widgetEmptyState">
                <ng-container *ngFor="let item of localItems;">
                    <div [id]='item.id'>
                        <div class="item" [class.item-delete]="isItemToBeDeleted(item.id)">
                            <p (click)="itemClicked(item)" class="name">{{item.name}}</p>
                            <p class="namevalueseperator"></p>
                            <i class="fa-solid fa-spinner fa-spin widget-item-spinner" *ngIf="item.value === ''"></i>
                            <p (click)="itemClicked(item)" *ngIf="item.value !== ''" class="value">{{item.value}}</p>
                            <a role="button" *ngIf="editVisible" class="widget-icon-action widget-icon-action--inline" (click)="addItemToRemoveList(item.id)">
                                <i class="fas fa-trash-alt fa-xs"></i>
                            </a>
                            <div class="moveitem" *ngIf="editVisible">
                                <i class="fas fa-bars fa-xs itemdraghandler widget-drag-handle"></i>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
            <ng-template #widgetEmptyState>
                <div class="widget-empty-state">
                    <span class="widget-empty-state__eyebrow">{{ 'NO_STATS' | translate }}</span>
                    <p class="widget-empty-state__copy">{{ 'ADD_SAVED_SEARCH_TO_START_TRACKING' | translate }}</p>
                </div>
            </ng-template>
        </div>
        <div class="widget-card__footer d-flex justify-content-end" *ngIf="!editVisible">
            <a (click)="addItem()" role="button" class="widget-text-action">{{ 'ADD_ANOTHER_STAT' | translate }}</a>
        </div>
        <div class="widget-card__footer widget-card__footer--editing d-flex justify-content-end">
            <a role="button" (click)="completeEdit()" *ngIf="editVisible" class="widget-text-action">{{ 'SAVE' | translate }}</a>
            <a role="button" (click)="cancelEdit()" *ngIf="editVisible" class="widget-text-action">{{ 'CANCEL' | translate }}</a>
        </div>
    </mat-card-content>
</mat-card>
